import React from 'react';
import { Link } from 'react-router-dom';
import './PriceComparisonPage.css';
import { getPriceComparisonUrl } from '../../utils/productUrlMapping';

/**
 * Button component that links to price comparison pages for specific products
 * 
 * @param {Object} props Component props
 * @param {string} props.productId - The product ID to find prices for
 * @param {string} props.productType - The product type category (e.g., "livescope", "screen")
 * @param {Object} props.style - Additional inline styles for the button
 * @param {string} props.className - Additional CSS classes for the button
 * @param {string} props.text - Custom button text (defaults to "Find Best Price")
 */
const FindBestPriceButton = ({ 
  productId, 
  productType, 
  style = {}, 
  className = "",
  text = "Find Best Price"
}) => {
  // Use centralized URL mapping to ensure consistent URLs across all components
  const getDestination = () => {
    // Use the centralized mapping function that handles CSV lookup IDs
    return getPriceComparisonUrl(productId);
  };

  return (
    <Link 
      to={getDestination()} 
      className={`find-best-price-button ${className}`}
      style={style}
    >
      <span className="button-text">{text}</span>
    </Link>
  );
};

export default FindBestPriceButton; 